export const T = {
  en_GB: { goalType: "Goal Type" },
  nb_NO: { goalType: "Måltype" },
} as const;
